import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import { __decorate, __extends } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Videos as videos } from "@/setup/videosInfo";

var InfoBtn =
/** @class */
function (_super) {
  __extends(InfoBtn, _super);

  function InfoBtn() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dialogVideo = false;
    _this.currentInfo = null;
    return _this;
  }

  InfoBtn.prototype.mounted = function () {
    var _this = this;

    videos.forEach(function (element) {
      if (element.moduleName === _this.$route.name) {
        _this.currentInfo = element;
      }
    });
  };

  InfoBtn = __decorate([Component({
    name: "InfoBtn",
    components: {}
  })], InfoBtn);
  return InfoBtn;
}(Vue);

export default InfoBtn;